import { createConfigSection } from '../helpers'

export default {
    ...createConfigSection('api', {
        base: 'https://beheer-test-api.agressieregistratieoverheid.nl',
        requestTimeout: 2000
    }),

    ...createConfigSection('oidc', {
        authority: 'https://localhost:8000' // local IDP
    })
}
